module.exports = __webpack_public_path__ + "img/main_story_slide1.2549bf58.jpg";